import {AttributeLink} from '@acng/frontend-stargazer';
import {off, on} from '@acng/frontend-bounty/dom/event.js';
import {scroll} from '@acng/frontend-bounty/style/view.js';

import {getState} from '../context/state.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

/**
 * | Phase   | Description                                                        |
 * | ------- | ------------------------------------------------------------------ |
 * | Connect | Scroll up on the element each time the local state gets activated. |
 *
 * @group DOM Attribute
 */
const name = 'state-scroll';

AttributeLink(name, () => (element) => {
  const state = getState(element);
  const scrollToTop = () => {
    DEBUG: if (debug(element)) console.log('scroll to top', {element});
    scroll(element, 0, 0);
  };

  on(state, 'active', scrollToTop);

  return () => off(state, 'active', scrollToTop);
});

export {name as STATE_SCROLL};
